// extracted by mini-css-extract-plugin
module.exports = {"svg":"action_svg__2leE0","action":"action_action__tVR4m","path1":"action_path1__1CxTk","palyIcon":"action_palyIcon__insg_"};